import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function getData() {
  return $apiClient.get(`${ApiConfig.USERS}`);
}
